import React, { useState } from 'react';
import { Map, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import Markers from './Markers';
import candidates from '../assets/candidates.json';
import './MapView.css';

const MapView = () => {

  const [currentLocation] = useState({lat:-22.930556,lng:-47.058833});
  const [zoom] = useState(12);
  const [candidate, setCandidate] = useState(null);
  const [totalVotes, setTotalVotes] = useState(0);
  const [radiusFactor, setRadiusFactor] = useState(1);
 
  const handleChange = (event) => {
    setTotalVotes(sumVotes(event.target.value));
    setCandidate(candidates.candidates[event.target.value]);
    if(candidates.candidates[event.target.value].DescCargo === "Prefeito"){
      setRadiusFactor(0.3)
    }
  };

  const sumVotes = (cand) =>{
    let totalVotes = 0;
    candidates.candidates[cand].escolas.map((escola) => {
      totalVotes = totalVotes + escola.quantidadeVotos;
      return 0;
    });
    return(totalVotes);
  }

  return (
    <Map center={currentLocation} zoom={zoom}>
      <div className="titulo">
        <p>Mapa de Votos - Campinas - 2020</p>
      </div>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
      />
      <div className="controles">
        <label>Selecione o candidato/a</label>
        <select onChange={handleChange}>
          {candidates.candidates.map((candidate, key) => {
            return (
              <option key={key} value={key}>{candidate.nomeCandidato}</option>
            )
          })}
        </select>
        <div id="boxTotalVotos">
          { totalVotes ? <p>Total de votos: {totalVotes}</p> : null} 
        </div>
      </div>
      {candidate ?
        <Markers candidate={candidate} radiusFactor={radiusFactor}/>
        :
        null}
      <footer className="rodape">
        <p>
          <a href="mailto:albordignon@gmail.com"
          >Desenvolvido por André Luís Bordignon</a
          >
        </p>
        <a rel="license" href="http://creativecommons.org/licenses/by-nc/4.0/">
          <img
            alt="Licença Creative Commons"
            // style="border-width: 0;"
            src="https://i.creativecommons.org/l/by-nc/4.0/88x31.png"
          />
        </a>
        <p>Este trabalho está licenciado com uma Licença</p>
        <a rel="license" href="http://creativecommons.org/licenses/by-nc/4.0/"
        >Creative Commons - Atribuição-NãoComercial 4.0 Internacional </a
        >
      </footer>
    </Map>
  );
}

export default MapView;
